var RequestTypes = {
  NEW_MATERIAL: 0,
  RENEWAL: 1,
  INTERVENTION: 2,
};

module.exports = RequestTypes;
